<template>
    <div>
 <!-- <table class="table" style="width:100%;border:1px solid  #EBEEF5;text-align: center;" > -->
              <!-- <thead>
                <tr>
                  <th style="text-align: center;">日期</th>
                  <th v-for="item in cheidFengxiang" :key="item.channelid"  style="text-align: center;">
                    <td   style="text-align: center;    display: flex;justify-content: center;">{{ lang_file == 'zh-cn'? item.unittype : item.unittype_en}}</td>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr  v-for="(item,index) in channelidList"
                    :key="index" >
                      <td  :class=" index % 2 == 0  ? 'warning' :'errof'" style="width:130px" v-if="conetnCunt != ''">{{channelidList[0].addtime}}</td>
                  <td
                    v-for="(tables,indexLit) in conetnCunt"
                    :key="indexLit"
                    :class=" index % 2 == 0  ? 'warning' :'errof'"
                  >{{item[tables]}}</td>
                 
                </tr> 
              </tbody>
            </table> -->
          <el-table :data="channelidList" border style="width: 100%" :row-class-name="tableRowClassName" max-height="600">
              <el-table-column prop="collecttime" label="日期" fixed  width="125"  v-if="conetnCunt != ''" ></el-table-column>
              <el-table-column  v-for="(item,index) in cheidFengxiang"  :prop="conetnCunt[index]" :label="lang_file == 'zh-cn'?item.unittype:item.unittype_en"  :key="item.channelid"></el-table-column>
            </el-table>
             <dataPheader :page-data="pageData" :total="total"  :get-table-list="linData"></dataPheader>
    </div>
</template>

<script>
import dataPheader from '@/components/common/dataPheader'
export default {
  components:{
    dataPheader
  },
    props:{
             channelidList:{
       type:Array,
       default:[]
    },
    cheidFengxiang:{
         type:Array,
       default:[]
    },
    conetnCunt:{
          type:Array,
       default:[]
    },
    pageData:{
      type:Object
    },
    total:{
      type:Number
    },
    linData:{
      type:Function
    },
    
    },
    data() {
        return {
            lang_file:'',
            channelidListFly:true,
        };
    },
    created() {

    },
    mounted() {
        this.lang_file = sessionStorage.getItem("lang_file")
    },
    methods: {
        // 斑马线
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    }
};
</script>

<style scoped lang="less">

</style>
